export const SAMPLE = { nickname: '太郎', name: '山田太郎', customerId: 'W12345' };
const PLACEHOLDER_RE = /\{[^}]+\}/g;
const MAP: Record<string, string> = {
  '{LINE:Nickname}': SAMPLE.nickname,
  '{SF:Name}': SAMPLE.name,
  '{SF:CustomerId__C}': SAMPLE.customerId,
};

export function renderPreview(input: string): { text: string; errors: string[] } {
  const errors: string[] = [];
  const text = input.replace(PLACEHOLDER_RE, (match) => {
    const mapped = MAP[match];
    if (mapped === undefined) {
      errors.push(match);
      return match;
    }
    return mapped;
  });
  return { text, errors };
}
